<template>
  <div class="channel-pkg">
    <div class="panel-header">
      <h3 class="panel-header__title">渠道包管理</h3>
      <span class="panel-header__subtitle">PACKAGE MANAGEMENT</span>
      <a class="panel-header__export" v-if="exportUrl" :href="exportUrl">导出</a>
    </div>
    <div class="panel-content">
      <h3 class="panel-content__title">
        渠道包管理
        <up-button type="primary" class="fr" @click="operateChannel('add')"><b>+&nbsp;</b>上传应用</up-button>
      </h3>
      <div class="panel-content__select-list">
        <span class="panel-content__label">状态：</span>
        <up-select class="panel-content__select-item is-small" v-model="verify" :data="verifyList"
                   clearable></up-select>
        <up-input class="panel-content__select-item" v-model="name" placeholder="应用名称"></up-input>
        <up-button class="ml20" type="primary" @click="searchChannel()">查询</up-button>
      </div>
      <div class="panel-content__table-wrap">
        <up-table class="panel-content__table" :page="page"
                  :widthColumns="{ id: 160, status_msg: 100, created_at: 160 }"
                  :slotContents="['icon', 'verify_msg']"
                  align="center"
                  show-overflow-tooltip
                  pagination
                  @up:current-change="({ currentPage }) => searchChannel(currentPage)"
                  @up:size-change="searchChannel()">
          <template slot="icon:content" slot-scope="{ row }">
            <img :src="row.icon" class="channel-pkg__icon">
          </template>
          <template slot="verify_msg:content" slot-scope="{ row }">
            <div>{{row.verify_msg}}</div>
            <div v-if="row.verify === 1 || row.verify === 3" class="is-none" :class="{ 'panel-content__table-link': row.verify === 3 }">{{ row.verify === 3 ? row.reason : row.updated_at }}</div>
          </template>
          <template slot="up:operate">
            <up-table-column width="156" fixed="right" label="操作">
              <template slot-scope="{ row }">
                <up-button class="is-edit" size="small" type="primary" @click="operateChannel('edit', row)">编辑
                </up-button>
                <up-button class="is-view" size="small" type="primary" @click="operateChannel('view', row)">查看
                </up-button>
                <up-button v-if="row.verify !== 3" class="is-remove" size="small" type="primary" @click="removeChannel(row)">删除
                </up-button>
              </template>
            </up-table-column>
          </template>
        </up-table>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { mapActions } from 'vuex'
import { BASE_URL } from '@/global/util/constants'

export default {
  name: 'package',
  data () {
    return {
      platform: '',
      verifyList: [],
      verifyMap: {},
      verify: '',
      name: '',
      page: new this.$page()
    }
  },
  computed: {
    exportUrl () {
      const params = { page: 1, per_page: 5000, ...this.getRequestParams() }
      return BASE_URL + `/${this.platform}/apps-channel/export?` + qs.stringify(params)
    }
  },
  methods: {
    ...mapActions([
      'channel/removeChannel',
      'channel/getChannels',
      'channel/getSelectData',
      'etcd/getItem'
    ]),
    operateChannel (type, row) {
      this.$router.push({ path: `/channel/${type}${type !== 'add' ? '/' + row.id : ''}` })
    },
    getRequestParams () {
      const { verify, name } = this
      const params = {}
      if (verify) { params.verify = verify }
      if (name) { params.name = name }
      return params
    },
    searchChannel (currentPage = 1) {
      this.page.currentPage = currentPage
      const params = this.getRequestParams()
      this.getChannels(params)
    },
    async removeChannel (row) {
      this.$msgbox({
        title: '温馨提示',
        message: `确定要删除ID为 “${row.id}” 的推广吗？`,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            const [err, res] = await this['channel/removeChannel']({ id: row.id })
            instance.confirmButtonLoading = false;
            if (err || res.code !== 1) {
              this.$message({ type: 'error', message: '删除渠道包失败！' })
            } else if (res.code === 1) this.$message({ type: 'success', message: '删除渠道包成功！' })
            done()
          } else {
            done();
          }
        }
      }).then(_ => {
        this.getChannels()
      })
    },
    async getChannels (params = {}) {
      const { pageSize, currentPage } = this.page
      this.page.loading = true
      const [, { data: { header, data: { data: { data, total } } } }] = await this['channel/getChannels']({
        platform: this.platform,
        params: {
          per_page: pageSize,
          page: currentPage,
          ...params
        }
      })
      this.page.setData({ header, data, total })
    },
    async getSelectData () {
      const [, { data: { verify: verifyList } }] = await this['channel/getSelectData']()
      this.verifyList = verifyList
      this.verifyMap = verifyList.reduce((prev, cur) => {
        prev[cur.value] = cur.name
        return prev
      }, {})
    }
  },
  created () {
    this.platform = this.$route.meta.platform
    this.getSelectData()

    const { name, value } = this.$route.query
    if (name && value) {
      this.key = value
      this.value = name
      this.getChannels({ [value]: name })
    } else {
      this.getChannels()
    }
  }
}
</script>

<style lang="scss">
  @include b(channel-pkg) {
    @include e(icon) {
      height: 72px;
    }

  }
</style>
